<template>
  <div>
    <p class="emd-text _color_subtle _type_caption eu-mb_1">
      {{ $t('charge.detail.payment-method.card.billing-address') }}
    </p>
    <p v-if="hasBillingAddress">
      {{ billingAddress.street }}, {{ billingAddress.number }},
      <span v-if="billingAddress.complement">
        {{ billingAddress.complement }},
      </span>
      <br />
      {{ billingAddress.neighborhood }}, {{ billingAddress.city || '-' }},
      {{ billingAddress.state || '-' }} -
      {{ billingAddress.country || '-' }}
      <span v-if="billingAddress.zip_code">
        - {{ billingAddress.zip_code }}
      </span>
    </p>
    <p v-else>-</p>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodCardsBillingAddres',

  props: {
    billingAddress: { required: true }
  },

  computed: {
    hasBillingAddress () {
      if (!this.billingAddress) return false
      return Object.keys(this.billingAddress).length > 0
    }
  }
}
</script>
